export enum ELocale {
  zh = 'CN', // 中文
  cn = 'CN', // 中文
  en = 'EN' // 英文
}
